import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=ad7b8966"
import script from "./ModalFooter.ts?vue&type=script&lang=ts&external"
export * from "./ModalFooter.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports